import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLtDown = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M24 33.628 9.586 19.214l2.122-2.121L24 29.385l12.293-12.292 2.121 2.121z" }) }) })
});
export default SvgArrowLtDown;
